import { Navigate } from 'react-router-dom';

const DEMO_EVENT_ID = 'f83c2769-b4aa-4ba9-9e3e-5e205fd40047';

const DemoScoringRedirect = () => {
  return <Navigate to={`/demo/scoring/${DEMO_EVENT_ID}`} replace />;
};

export default DemoScoringRedirect;
